const { GODADDY_PL_ID } = require('./constants');

export const getProductPath = ({ product, requestContext }) =>
  requestContext.plId === GODADDY_PL_ID ? product.slug : 'topic/' + product.id;

export const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
